var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "d-flex", attrs: { flat: "" } },
    [
      _c(
        "v-card",
        { staticClass: "pt-3", attrs: { flat: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "", disabled: _vm.disabled },
              on: { click: _vm.previous },
            },
            [_c("v-icon", [_vm._v("fast_rewind")])],
            1
          ),
          !_vm.update
            ? _c(
                "v-btn",
                {
                  attrs: { icon: "", disabled: _vm.disabled },
                  on: { click: _vm.play },
                },
                [_c("v-icon", [_vm._v("play_arrow")])],
                1
              )
            : _c(
                "v-btn",
                {
                  attrs: { icon: "", disabled: _vm.disabled },
                  on: { click: _vm.pause },
                },
                [_c("v-icon", [_vm._v("pause")])],
                1
              ),
          _c(
            "v-btn",
            {
              attrs: { icon: "", disabled: _vm.disabled },
              on: { click: _vm.next },
            },
            [_c("v-icon", [_vm._v("fast_forward")])],
            1
          ),
        ],
        1
      ),
      _vm.playMode
        ? _c(
            "v-radio-group",
            {
              attrs: {
                row: "",
                dense: "",
                disabled: _vm.disabled || Boolean(_vm.update),
              },
              model: {
                value: _vm.computedPlayMode,
                callback: function ($$v) {
                  _vm.computedPlayMode = $$v
                },
                expression: "computedPlayMode",
              },
            },
            [
              _c("v-radio", { attrs: { label: "Daily", value: "daily" } }),
              _c("v-radio", {
                attrs: { label: "Streaming", value: "streaming" },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card",
        { staticClass: "pt-3", attrs: { "max-width": "90px", flat: "" } },
        [
          _c("v-select", {
            attrs: {
              label: "Speed",
              items: _vm.speedItems,
              dense: "",
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.streamSpeed,
              callback: function ($$v) {
                _vm.streamSpeed = $$v
              },
              expression: "streamSpeed",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }